import React from 'react'
import Title from '../../../atoms/Title'
import Card from '../../../molecules/Card'
import { GoArrowLeft } from "react-icons/go";
import bigPic from "../../../../assets/pics/bigpic.png"
import smallPic from "../../../../assets/pics/square.jpg"
import Button from './../../../atoms/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Newssection({data}) {
  // console.log("news in home data",data)
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const featuredNews = data?.[0];
  const featuredTitle = isArabic ? featuredNews?.titleA : featuredNews?.titleE;
  const featuredDate = isArabic
    ? featuredNews?.createDate
    : featuredNews?.createDateE;
  const noData = t("common.noData");
  const navigate = useNavigate()
  const onAllBtnClick=()=>{
    console.log("beooooooooooo")
    navigate("/allnews")

  }

  const news = [
    {
      id: 1,
      title: "استجابة سريعة لسرقة لوحة حمدي قنديل",
      date: "1 نوفمبر 2023",
      description: "بناءًا علي توجيهات معالي وزير الثقافة دكتورة /نيفين الكيلاني ، قام الجهاز القومي للتنسيق الحضاري برئاسة مهندس محمد ابو سعده باعاده تركيب لوحة بدل اللوحة المفقودة للكاتب الكبير حمدي قنديل.",
      imageSrc: bigPic,
      alt: "big image",
      type: "bigsquare", // Card type for styling
    },
    {
      id: 2,
      title: "التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date: "1 نوفمبر 2023",
      description: "",
      imageSrc: smallPic,
      alt: "small image",
      type: "square", // Card type for styling
    },
    {
      id: 3,
      title: "التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date: "1 نوفمبر 2023",
      description: "",
      imageSrc: smallPic,
      alt: "small image",
      type: "square",
    },
    {
      id: 4,
      title: "التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date: "1 نوفمبر 2023",
      description: "",
      imageSrc: smallPic,
      alt: "small image",
      type: "square",
    },
  ];
  
  // const navigate = useNavigate();

  const handleCardClick = (newsId) => {
    navigate(`/allnews/${newsId}`); // Navigate to the news details page with the ID
  };

  return (
    <div className='h-full pb-[30px]'>
        <div className='flex justify-start items-center ms-[25px]'>
                  <div className='pb-[8px] bg-rd-400'>

                      <Title primary>{t("home.news.title")}</Title>
                  </div>  
                <div className="h-[3px] w-3/5 md:w-3/4 bg-[#F5F5F5] mx-[10px] md:mx-[20px] lg:mx-[80px]"></div>
            </div>

      
      
      <div className='flex flex-row justify-start items-center px-[10px] md:px-[40px] lg:px-[50px] mt-[5px]'>
        <div className='flex flex-col md:flex-row justify-around items-center w-full bg-ed-400'>
            
            <div className='mx-2 bg-yellw-400'>
            <Link to={`/allnews/${featuredNews?.id}`}>
              <Card
              vertical
              title={featuredTitle || noData}
              date={featuredDate || noData}
              // imageSrc={bigPic}
              imageSrc={featuredNews?.image}
              alt={featuredTitle}
              bigsquare
              />
              </Link>
            </div>
            <div>

            {/* {news.slice(1).map((newss, index)=> */}
            {data?.slice(1).map((newss, index)=>
              <div key={index} className='my-[15px]'>
              <Link to={`/allnews/${newss?.id}`}>
                  <Card
                    horizontal
                    title={(isArabic ? newss?.titleA : newss?.titleE) || noData}
                    date={(isArabic ? newss?.createDate : newss?.createDateE) || noData}
                    // imageSrc={smallPic}
                    imageSrc={newss?.image}
                    alt={isArabic ? newss?.titleA : newss?.titleE}
                    square
                    />
                </Link>
              </div>
            )}
              
            </div>
        </div>
      </div>




      <div className='md:px-[50px] md:me-[38px] flex justify-center items-center md:block md:justify-start md:items-start'>
          {/* <Button primary rounded blackText onClick={onAllBtnClick}> */}
          <Button secondaryNews rounded onClick={onAllBtnClick}>
          {t("common.more")}
          {/* <GoArrowLeft className='mr-[15px] text-black'/> */}
          </Button>
      </div>
    </div>
  )
}
